import React, { useEffect, useState } from "react";
/* import { ReactComponent as Loupe } from "common/src/assets/icon-component/loupe.svg"; */
import { useTranslation } from "react-i18next";
import { printAmount } from "common/src/helpers/functions";
import TournamentTable from "common/src/component/TournamentTable";
import { Link } from "react-router-dom";
import {
  CustomSelect,
  SidePanelBottom,
  SidePanelDiv,
  SidePanelOverley,
  SidePanelRegister,
  SidePanelSearchWrapper,
  SidePanelSelect,
  SidePanelTable,
  SidePanelTop,
  SidePanelVerticalExpand,
  SidePanelWrapper,
  TabWinner,
  TournamentInfoDiv,
} from "../styledComponents/StyledGame";
import { GamesSearch } from "./GamesSearch";
import { useApolloClient } from "@apollo/client";
import { QUERY_GET_RECENT_WINNERS } from "../graphql/queries";

const SidePanel = ({
  sidepanel,
  setShowChallengeDialog,
  playerCurrency,
  server,
  player,
  gameDetails,
  pages,
  realheight,
  currentLanguage,
  currency,
  imagesPath,
  gameImagePath,
  skin,
  tournaments,
  setShowTournamentPopover,
  sidepanelHeight,
}) => {
  const [currentDisplay, setCurrentDisplay] = useState("winners");
  const [showAll, setShowAll] = useState(false);
  const [currentWinners, setCurrentWinners] = useState([]);
  const [hideOnSearch, setHideOnSearch] = useState(false);
  const [recentWinners, setRecentWinners] = useState(null);
  const { t } = useTranslation("");
  const apolloClient = useApolloClient();

  useEffect(() => {
    const getRecentWiners = async (currency) => {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_RECENT_WINNERS,
        variables: { currency: currency },
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return <h1>`Error: ${errors}`</h1>;
      setRecentWinners(data.getRecentWinners);
      return null;
    };
    getRecentWiners(currency);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (recentWinners !== null) {
      //console.log("winner " + JSON.stringify(recentWinners.recent));
      setCurrentWinners(recentWinners.recent);
    }
  }, [recentWinners]);

  const handleWinnersChange = (e) => {
    //winners = recentWinners.e;
    //console.log(recentWinners);
    setCurrentWinners(recentWinners[e]);
    // console.log("winner " + JSON.stringify(currentWinners));
  };

  const changeTab = (tab) => {
    setCurrentDisplay(tab);
  };

  return (
    <SidePanelWrapper isOpened={sidepanel} isClosed={!sidepanel}>
      {skin === "plc" && <SidePanelVerticalExpand />}
      <SidePanelDiv>
        <SidePanelTop isClosed={!sidepanel}>
          {/* <VerticalExpendSvg className="verical-expand-svg" /> */}
          <SidePanelSearchWrapper>
            <GamesSearch
              setHideOnSearch={setHideOnSearch}
              serverSetup={server}
              gameImagePath={gameImagePath}
              specialProp={true}
              skin={skin}
            />
          </SidePanelSearchWrapper>
          <SidePanelSelect hideonsearch={hideOnSearch}>
            {currentDisplay === "winners" ? (
              <CustomSelect
                onChange={(e) => handleWinnersChange(e.target.value)}
              >
                <option value="recent">{t("label_now")}</option>
                <option value="week">{t("label_week")}</option>
                <option value="month">{t("label_month")}</option>
              </CustomSelect>
            ) : (
              <TabWinner onClick={() => changeTab("winners")}>
                {t("label_winners", "Winners")}
              </TabWinner>
            )}
          </SidePanelSelect>
          {sidepanel && skin !== "plc" && (
            <div className="row px-3 mt-3">
              <TabWinner
                className="col-6 text-center text-uppercase"
                onClick={() => changeTab("tournament")}
              >
                {t("label_tournament", "Tournament")}
              </TabWinner>
              <TabWinner
                type="button"
                className="col-6 text-center text-uppercase"
                onClick={() => changeTab("challenge")}
              >
                {t("label_challenge", "Challenge")}
              </TabWinner>
            </div>
          )}
        </SidePanelTop>
        <SidePanelTable
          style={{
            height: sidepanelHeight,
          }}
          showAll={!showAll}
        >
          {currentDisplay === "challenge" ? (
            <>
              <img
                src={
                  server.cdn +
                  imagesPath +
                  (server.currentLanguage === "en"
                    ? ""
                    : server.currentLanguage + "/") +
                  "challenge_image.jpg"
                }
                style={{ maxWidth: "100%" }}
                alt="challenge_image.jpg"
              ></img>
              <h3>{t("challenge_title")}</h3>
              <button
                className="btn float-right"
                onClick={() => setShowChallengeDialog(true)}
              >
                {t("label_more_info")}
              </button>
            </>
          ) : (
            <table>
              <tbody>
                {currentDisplay === "winners" &&
                  currentWinners.map((winner, key) => (
                    <tr key={key}>
                      <th>{winner.firstName}</th>
                      <th>
                        <Link
                          to={
                            "/" +
                            currentLanguage +
                            "/" +
                            winner.gameType.toLowerCase().replace(" ", "-") +
                            "/" +
                            winner.details
                          }
                        >
                          {winner.gameID}
                        </Link>
                      </th>
                      <th>
                        {printAmount(
                          winner.win,
                          currency,
                          server.currencies,
                          true
                        )}
                      </th>
                    </tr>
                  ))}
                {currentDisplay === "tournament" && (
                  <>
                    <TournamentTable
                      playerCurrency={playerCurrency}
                      showAll={showAll}
                      server={server}
                      displayName={false}
                      skin={skin}
                      tournamentGame={
                        gameDetails && gameDetails.game.internalID
                      }
                    />
                  </>
                )}
              </tbody>
            </table>
          )}
        </SidePanelTable>
        {currentDisplay !== "challenge" && (
          <SidePanelOverley
            onClick={() => setShowAll(!showAll)}
          ></SidePanelOverley>
        )}
        <SidePanelBottom>
          {!player && (
            <SidePanelRegister>
              {t("label_win_real_money", "Win real money")}
              <Link to={pages["register"]}>
                {t("label_register_now", "Register Now")}
              </Link>
            </SidePanelRegister>
          )}
          {sidepanel && skin !== "plc" && (
            <TournamentInfoDiv onClick={() => setShowTournamentPopover(true)}>
              {tournaments !== null && tournaments.length > 0
                ? t("label_tournament_information")
                : t("label_without_tournament_information")}
            </TournamentInfoDiv>
          )}
        </SidePanelBottom>
      </SidePanelDiv>
    </SidePanelWrapper>
  );
};

export default SidePanel;
